<template>
  <main>
    <b-container v-if="project">
      <div class="page-breadcrumb">
        <router-link
            :to="{ name: 'ProjectView', params: { id: project._id } }"
            ><i class="fa fa-angle-left" /> Back to project</router-link
        >
      </div>

      <div class="section-header">
        <h1 class="heading">Edit {{ project.name }}</h1>

        <div class="actions"></div>
      </div>

      <div class="layoutcard">
        <b-row>
          <b-col cols="8" lg="7">
            <ProjectForm :form="form" @callback="submit"></ProjectForm>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </main>
</template>

<script>
import { setTimeout } from "timers";
import { mapActions } from "vuex";
import InitAdmin from "../Shared/InitAdmin";
import ProjectForm from "./ProjectForm";

export default {
  name: "ProjectEdit",
  components: {
    ProjectForm
  },
  extends: InitAdmin,
  data() {
    return {
      project: null,
      form: {
        name: null,
        description: null,
        tag: null
      }
    };
  },
  mounted() {
    this.loadProject({ id: this.$route.params.id }).then(res => {
      this.project = res;
      this.form.name = this.project.name;
      this.form.description = this.project.description;
      this.form.tag = this.project.tag.split(",");
    });
  },
  methods: {
    ...mapActions(["loadProject", "updateProject"]),
    submit() {
      const data = {
        name: this.form.name,
        description: this.form.description,
        tag: this.form.tag.toString()
      };

      this.updateProject({
        projectId: this.project._id,
        project: data
      }).then(() => {
        this.$toasted.show("Project saved");
        setTimeout(() => {
          this.$router.push({
            name: "ProjectView",
            params: { id: this.project._id }
          });
        }, 1000);
      });
    }
  }
};
</script>
